import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { useSelector, useDispatch } from 'react-redux';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { isMobile } from 'react-device-detect';
import { Collapsible, CollapsiblePanel, CollapsibleContent } from '@americanexpress/dls-react';
import Clean from '../icons/Clean.svg';
import Crumpled from '../icons/Crumpled.svg';
import Light from '../icons/Light.svg';
import LineUp from '../icons/LineUp.svg';
import FlashOff from '../icons/FlashOff.svg';
import Mobile from '../icons/Mobile.svg';
import smMobile from '../icons/smMobile.svg';
import smMobileGrey from '../icons/smMobileGrey.svg';
import smDesktop from '../icons/smDesktop.svg';
import smDesktopGrey from '../icons/smDesktopGrey.svg';
import Document from '../icons/Document.svg';

const DocUploadTips = ({
  uploadTips,
  stepNumber,
  showStepNumber,
  languageData,
}) => {
  const dispatch = useDispatch();
  const [isMobileView, setIsMobileView] = useState(isMobile);
  const locale = useSelector((state) => state.getIn(['intl', 'activeLocale']));
  useEffect(() => {
    dispatch(loadLanguagePack('axp-doc-upload-tips', { fallbackLocale: 'en-US' }));
  }, [locale]);

  const handleViewType = (type) => {
    if (type === 'mobile') {
      setIsMobileView(true);
    } else {
      setIsMobileView(false);
    }
    return null;
  };

  const renderTips = () => {
    const iconStyle = {
      width: '48px',
      height: '48px',
      marginLeft: 'auto',
      marginRight: 'auto',
    };
    return uploadTips.map((tip, idx) => {
      const formattedMsg = `tip${idx}${isMobileView ? 'M' : 'D'}`;
      if (isMobileView) {
        return (
          <div
            key={tip.key}
            className="flex flex-column col-md-3 pad-tb text-align-center body-1 pad-2-lr border-xs-b stack"
          >
            {tip.iconM !== null && (
              <img src={tip.iconM} style={iconStyle} alt={formattedMsg} />
            )}
            <FormattedMessage id={formattedMsg} />
          </div>
        );
      }
      return (
        <div
          key={tip.key}
          className="flex flex-column col-md-3 pad-tb text-align-center body-1 pad-2-lr border-xs-b stack"
        >
          {tip.iconD !== null && (
            <img src={tip.iconD} style={iconStyle} alt={formattedMsg} />
          )}
          <FormattedMessage id={formattedMsg} />
        </div>
      );
    });
  };

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <div className="margin-auto-lr">
        <div className="flex flex-row flex-justify-end border-dark-t">
          <button
            type="button"
            className="btn-icon icon-hover btn-inline border-dark-lr border-dark-b"
            aria-labelledby="tag-btn"
            style={{ height: '48px' }}
            data-testid="mobileBtn"
            onClick={() => handleViewType('mobile')}
          >
            <img src={isMobileView ? smMobile : smMobileGrey} alt="mobile icon" />
          </button>
          <button
            type="button"
            className="btn-icon icon-hover btn-inline border-dark-r border-dark-b margin-4-r"
            aria-labelledby="tag-btn"
            data-testid="desktopBtn"
            onClick={() => handleViewType('desktop')}
          >
            <img src={isMobileView ? smDesktopGrey : smDesktop} alt="desktop icon" />
          </button>
        </div>
        <Collapsible>
          <CollapsiblePanel
            id="collapsible-p-h3"
            className="text-align-center border-0"
            theme={{
              fontFamily: 'Helvetica Neue,Helvetica,sans-serif',
              fontWeight: '600',
              fontSize: '1rem',
              lineHeight: '1.5rem',
              color: '#333 !important',
            }}
          >
            {showStepNumber && stepNumber}
            <FormattedMessage id="title" />
          </CollapsiblePanel>
          <CollapsibleContent
            labelledBy="collapsible-p-h3"
            className="row"
            theme={{ backgroundColor: '#ffffff' }}
          >
            <div className="flex flex-column-sm-down">
              {renderTips()}
            </div>
          </CollapsibleContent>
        </Collapsible>
      </div>
    </IntlProvider>
  );
};

DocUploadTips.defaultProps = {
  stepNumber: '2.\u00A0',
  showStepNumber: true,
  uploadTips: [
    {
      key: '1',
      iconM: Mobile,
      iconD: LineUp,
    },
    {
      key: '2',
      iconM: FlashOff,
      iconD: Crumpled,
    },
    {
      key: '3',
      iconM: LineUp,
      iconD: Document,
    },
    {
      key: '4',
      iconM: Light,
      iconD: Clean,
    },

  ],
  languageData: {},
};

DocUploadTips.propTypes = {
  stepNumber: PropTypes.string,
  showStepNumber: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types -- uploadTips contains mixed icon and metadata values
  uploadTips: PropTypes.arrayOf(PropTypes.any),
  languageData: PropTypes.instanceOf(Object),
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(loadLanguagePack('axp-doc-upload-tips', { fallbackLocale: 'en-US' }));
};

DocUploadTips.holocron = {
  name: 'axp-doc-upload-tips',
  loadModuleData,
};

const UnwrappedDocUploadTips = DocUploadTips;
export { UnwrappedDocUploadTips };

export default compose(
  oneAppModuleWrapper('axp-doc-upload-tips')
)(DocUploadTips);
